










































import { computed, defineComponent } from "@vue/composition-api"
import {
  useFindOneBooking,
  useStartBooking,
  useReserveBooking,
} from "@/app/reactive/booking"
import Address from "@/app/components/facility/Address.vue"
import Subtitle from "@/app/components/common/Subtitle.vue"
import Content from "@/app/components/common/Content.vue"
import Hint from "@/app/components/common/Hint.vue"
import { FacilityModel } from "@/app/models/facility.model"
import {
  getTariffCapacityClass,
  getTariffCapacityLabel,
} from "@/app/utils/tariff-capacity-display"
import { TariffReservationMode } from "@/app/models/tariff.model"

export default defineComponent({
  name: "FacilityControls",
  components: {
    Address,
    Subtitle,
    Content,
    Hint,
  },
  props: {
    facility: {
      type: Object as () => FacilityModel,
      required: true,
    },
  },
  setup(props, { root }) {
    const { startBooking } = useStartBooking()
    const { reserveBooking } = useReserveBooking()
    const { booking } = useFindOneBooking()

    const flexTariff = computed(() => {
      return props.facility.tariffs.find(
        tariff => tariff.uuid === booking.value.tariff?.uuid,
      )
    })

    const tariffCapacityLabel = computed(() => {
      const tariff = flexTariff.value
      if (!tariff) {
        return null
      }

      return getTariffCapacityLabel(tariff, {
        fullLabel: freeAmount =>
          String(root.$t("facility.detail.slots", { amount: freeAmount })),
        binaryLabel: ({ isFull, freeAmount, tariff }) =>
          String(
            root.$tc(
              `facility.detail.capacityBinary.${tariff.tariffType.name}.${
                isFull ? "full" : "free"
              }`,
              isFull ? 0 : freeAmount,
            ),
          ),
      })
    })

    const tariffCapacityClass = computed(() => {
      const tariff = flexTariff.value
      if (!tariff) {
        return ""
      }

      return getTariffCapacityClass(tariff)
    })

    const reservationsEnabled = computed(
      () =>
        booking.value.tariff?.reservationMode !== TariffReservationMode.NONE,
    )

    async function start() {
      await startBooking(booking)
    }

    async function reserve() {
      await reserveBooking(booking)
    }

    return {
      booking,
      start,
      reserve,
      stop,
      tariffCapacityLabel,
      tariffCapacityClass,
      reservationsEnabled,
    }
  },
})
